export default __webpack_public_path__ + "static/media/AlchemyBG-Login.2c79b7d4.jpg";